export const isDevelopment = import.meta.env.DEV;
export const isProduction = import.meta.env.PROD;

export const THEME_STORAGE_KEY = 'themeName';

export * from './defaultCompanySearchFilters';
export * from './companyAssetTypes';
export * from './externalLinks';
export * from './financialTabIcons';
export * from './routes';
export * from './userFacingFeatures';
